import React from 'react';
import { func, bool } from 'prop-types';
import { Modal } from 'react-bootstrap';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

function Signup({show,onClose,onLogin,isSignUp,t}) {
	return(
		<Modal
			show={show}
			onHide={onClose}
		>
			<Modal.Header>
				<style.Header>
					{isSignUp ? t('landing.Signup') : t('landing.Login')}
				</style.Header>
			</Modal.Header>
			<Modal.Body>
				<style.Body>
					<style.Description>
						{t('landing.SignupText')}
					</style.Description>
					<style.IconButton onClick={onLogin}><style.SignInWithGoogleLogo /></style.IconButton>
				</style.Body>
			</Modal.Body>
			<Modal.Footer>
				<style.Footer>
					<style.TextButton onClick={onClose}>{t('header.Close')}</style.TextButton>
				</style.Footer>
			</Modal.Footer>
		</Modal>
	);
}
Signup.propTypes = {
	show : bool.isRequired,
	onClose : func.isRequired,
	onLogin : func.isRequired,
	isSignUp : bool,
	t : func.isRequired
};


export default withNamespaces()(Signup);

